import React from 'react';
import { LayoutHOC } from 'base/ui/layout/layout';
import { createCheckSMDetail } from './checkStateMarketingDetail';

export const createCheckSMDetailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createCheckSMDetail());
};
